import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import baseUrl from "../api/utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Gstr1ExportView = () => {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const MySwal = withReactContent(Swal);

  const today = new Date();
  const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

  const [fromDate, setFromDate] = useState(firstOfMonth.toISOString().split("T")[0]);
  const [toDate, setToDate] = useState(today.toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);

  const handleDownloadJson = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/reports/gstr1/export-json`, {
        headers: { Authorization: token },
        params: { from: fromDate, to: toDate },
      });

      const jsonStr = JSON.stringify(res.data, null, 2);
      const blob = new Blob([jsonStr], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `GSTR1_${fromDate}_to_${toDate}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      MySwal.fire({
        icon: "success",
        title: "Downloaded",
        text: "GSTR-1 JSON file downloaded successfully.",
      });
    } catch (err) {
      if (err.response?.status === 401) {
        navigate("/unauthorized");
        return;
      }
      MySwal.fire({
        icon: "error",
        title: "Download Failed",
        text: err.response?.data || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ background: "#f5f6fa", padding: "20px", borderRadius: "8px" }}>
      <div style={{ background: "#fff", borderRadius: "10px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
        <h5 style={{ marginBottom: "16px" }}>Export GSTR-1</h5>
        <p style={{ color: "#888", fontSize: "13px", marginBottom: "20px" }}>
          Generates a GSTR-1 file with B2B, B2C Large, B2C Small, and HSN Summary data for the selected period.
        </p>

        <div style={{ display: "flex", gap: "12px", alignItems: "flex-end", marginBottom: "20px" }}>
          <div>
            <label style={{ fontSize: "11px", color: "#888", fontWeight: "600", display: "block", marginBottom: "4px" }}>From Date</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={{ padding: "7px 10px", border: "1px solid #ddd", borderRadius: "4px", fontSize: "13px" }}
            />
          </div>
          <div>
            <label style={{ fontSize: "11px", color: "#888", fontWeight: "600", display: "block", marginBottom: "4px" }}>To Date</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={{ padding: "7px 10px", border: "1px solid #ddd", borderRadius: "4px", fontSize: "13px" }}
            />
          </div>
        </div>

        <button className="btn btn-primary" onClick={handleDownloadJson} disabled={loading}>
          {loading ? "Generating..." : "Download GSTR-1 (JSON)"}
        </button>

        <p style={{ fontSize: "11px", color: "#999", marginTop: "8px" }}>
          Note: This file is structured according to standard GSTR-1 requirements. 
          We recommend a test upload or reviewing with your CA before final filing.
        </p>
      </div>
    </div>
  );
};

export default Gstr1ExportView;